module.exports = __webpack_public_path__ + "img/image3.ca0e1de8.jpg";